<template>
  <app-modal
    v-model="isDialogOpened"
    size="md"
    @cancel="closeDialog"
  >
    <template #title>
      <span class="text--large text--bold">
        {{ $t('project.nda.dialogs.NdaDeletionDialog.title') }}
      </span>
    </template>

    <template #body>
      {{ $t('project.nda.dialogs.NdaDeletionDialog.body') }}
    </template>

    <template #footer>
      <app-button
        type="outlined"
        variant="neutral"
        @click="closeDialog"
      >
        {{ $t('common.cancel') }}
      </app-button>
      <app-button
        class="ml-4"
        :disabled="isOkDisabled"
        @click="onOk"
      >
        {{ $t('common.delete') }}
      </app-button>
    </template>
  </app-modal>
</template>

<script>
import { defineComponent } from 'vue'

import { dialogMixin } from '@/mixins/dialogMixin'

export default defineComponent({
  name: 'NdaDeletionDialog',
  mixins: [dialogMixin],
  methods: {
    onOk () {
      this.$emit('confirm')
      this.closeDialog()
    },
  },
})
</script>
